import auth0 from 'auth0-js'
import Router from '../router/index'
import NotificationService from '@/services/NotificationService'

export default {
  methods: {
    login () {
      let webAuth = new auth0.WebAuth({
        clientID: this.cpAuth.clientId,
        domain: this.cpAuth.domain,
        redirectUri: this.cpAuth.redirectUrl,
        responseType: this.cpAuth.responseType,
        scope: this.cpAuth.scope
      })

      webAuth.popup.authorize({
        redirectUri: this.cpAuth.redirectUrl
      }, function (err, authResult) {
        console.log(err)
      })

      window.addEventListener('message', this.cpCallback)
    },

    logout () {
      this.$store.dispatch('cpAuth/logout')
      NotificationService.message('You are logged out now...')
    },

    cpCallback () {
      if (typeof event.data === 'string') {
        let authData = {}
        try {
          authData = JSON.parse(event.data)
        } catch (e) {
          return
        }

        const responsePromise = this.$store.dispatch('cpAuth/login', {
          authData
        })

        responsePromise.then(response => {
          Router.go('/orders')
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
}
